import { crv, cva } from '@/styled-system/css';

export const progressStepperStepLabelRecipe = cva({
  base: {
    'textWrap': 'balance',

    '& > [data-c11n-component="Tag.Root"]': {
      marginBlockStart: 'ProgressMeter.padding.tag-top',
    },
  },
  variants: {
    alignLabel: { center: {}, left: {} },
    orientation: { vertical: {}, horizontal: {} },
    ...crv('labelAppearance', {
      all: {
        'display': 'block',
        '&[data-c11n-component="ProgressStepper.CurrentLabel"]': {
          display: 'none',
        },
      },
      current: {
        '&': {
          display: 'none',
        },

        '&[data-c11n-component="ProgressStepper.CurrentLabel"]': {
          display: 'block',
        },

        '[data-orientation="vertical"] &': {
          display: 'block',
        },

        '[data-orientation="vertical"] &[data-c11n-component="ProgressStepper.CurrentLabel"]': {
          display: 'none',
        },
      },
      none: {
        display: 'none',
      },
    }),
  },
  compoundVariants: [
    {
      orientation: 'vertical',
      alignLabel: ['center', 'left'],
      css: {
        textAlign: 'left',
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'left',
      css: {
        textAlign: 'left',
      },
    },
    {
      orientation: 'horizontal',
      alignLabel: 'center',
      css: {
        textAlign: 'center',
      },
    },
  ],
});
